import { Select } from "antd";
import { setProducts } from "app/slices/order-product/CreateOrder";
import { flashsaleService } from "modules/flash-sale/service";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toNonAccentVietnamese } from "utils";

interface IChildCategorySelect {
    record: any;
}

const ChildCategorySelect = (props: IChildCategorySelect) => {
    const { record } = props;
    const dispatch = useDispatch();
    const createOrderData = useSelector((state: any) => state.createOrder.data);
    const targetItem = createOrderData?.find((item: any) => item?.id === record?.id);

    const [categories, setCategories] = React.useState<any[]>([]);

    const onGetChildCategories = async () => {
        try {
            const payload = {
                page: 1,
                limit: 100,
                status: 1,
                parent_id: targetItem?.parent_category,
            };
            const res: any = await flashsaleService.getParentCategories(payload);
            if (res?.status) {
                const data = res?.data?.map((item: any) => ({ ...item, label: item?.name, value: item?.id }));
                setCategories(data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onChange = (value: any) => {
        const newData = createOrderData?.map((item: any) => {
            if (item?.id === record?.id) {
                return {
                    ...item,
                    child_category: value,
                    product: undefined,
                    quantity: 1,
                    price: 0,
                    sale_price: 0,
                    total_price: 0,
                    weight: 0,
                    product_price_id: undefined,
                    attribute: undefined,
                };
            }
            return item;
        });
        dispatch(setProducts(newData));
    };

    React.useEffect(() => {
        if (targetItem?.parent_category) onGetChildCategories();
    }, [targetItem?.parent_category]);

    return (
        <Select
            style={{ width: "100%" }}
            showArrow
            placeholder="Chọn danh mục con"
            showSearch
            allowClear
            value={targetItem?.child_category}
            disabled={!targetItem?.parent_category}
            options={categories}
            filterOption={(input, option: any) => {
                const nonAccent = toNonAccentVietnamese(option?.label).toLowerCase();
                const nonAccentInput = toNonAccentVietnamese(input).toLowerCase();
                return nonAccent.includes(nonAccentInput);
            }}
            onChange={onChange}
        />
    );
};

export default ChildCategorySelect;
